import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7my2jr2fhg: FaireBrandEntity = {
  token: "b_7my2jr2fhg",
  type: "brand",
  name: "Miami Sample Apparel",
  avatarUrl:
    "https://cdn.faire.com/fastly/a117552556018bd1b26a81d969f8e4307b1d7a59dc5c4fac26f9029aeac7e203.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1c41d308fbc4d7b45204019e54477fa1537afad3ff9c0c316ac136a80fd06606.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a117552556018bd1b26a81d969f8e4307b1d7a59dc5c4fac26f9029aeac7e203.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1c41d308fbc4d7b45204019e54477fa1537afad3ff9c0c316ac136a80fd06606.jpeg",
  location: "Miami, FL, USA",
  minimumOrderDollars: 100,
  rating: 2.7,
  reviewCount: 18,
  isInsider: true,
  description:
    "Founded in Miami in 2020, Miami Sample Apparel was created from a love of effortless style and the vibrant spirit of the city. Inspired by Miami’s sunshine, energy, and diverse culture, the brand focuses on feminine pieces that are both modern and timeless.\n\nMiami Sample Apparel offers thoughtfully designed clothing that blends classic silhouettes with contemporary trends. Our collections feature versatile dresses, tops, and everyday essentials that are flattering, comfortable, and easy to wear. We believe great style should feel natural and accessible, offering pieces that help women feel confident without sacrificing comfort or value.\n\nAs a small, family-run brand, we approach fashion with care and intention. Every collection is created with attention to detail and a deep appreciation for the women who wear our designs. Our goal is not just to create clothing, but to build a community that celebrates individuality, confidence, and personal expression.\n\nAt the heart of Miami Sample Apparel is a simple belief: beauty has no boundaries. We design pieces that allow women to express their unique style and feel like the best version of themselves—every day.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:55.632Z",
    importedBy: "entity-db-cli",
  },
};
